import React, { useState } from 'react'
import PropTypes from 'prop-types'
import noop from 'lodash/noop'
import { Controller } from 'react-hook-form'
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker'
import StyledPickersTextField from 'components/form-fields/v5/StyledPickersTextField'

const HHFormDesktopDatePicker = ({
  label = '',
  name,
  control,
  rules = undefined,
  required = false,
  TextFieldProps = {},
  PopperProps = {},
  restSlots = {},
  restSlotProps = {},
  onChange = noop,
  ...rest
}) => {
  const [isCalendarOpen, setIsCalendarOpen] = useState(false)
  const onOpen = () => setIsCalendarOpen(true)
  const onClose = () => setIsCalendarOpen(false)
  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({ field }) => {
        const { ref, onChange: onChangeHookForm, onBlur, value, ..._rest } = field
        return (
          <DesktopDatePicker
            label={label}
            open={isCalendarOpen}
            onOpen={onOpen}
            onClose={onClose}
            disableScrollLock
            value={value}
            slots={{ textField: StyledPickersTextField, ...restSlots }}
            slotProps={{
              textField: { onClick: onOpen, fullWidth: true, ...TextFieldProps },
              popper: { ...PopperProps },
              ...restSlotProps,
            }}
            onChange={(...params) => {
              onChangeHookForm(...params)
              onChange(...params)
            }}
            {..._rest}
            {...rest}
          />
        )
      }}
    />
  )
}

HHFormDesktopDatePicker.propTypes = {
  label: PropTypes.string,
  TextFieldProps: PropTypes.object,
  PopperProps: PropTypes.object,
  restSlots: PropTypes.object,
  restSlotProps: PropTypes.object,
  name: PropTypes.string.isRequired,
  control: PropTypes.object.isRequired,
  rules: PropTypes.object,
  required: PropTypes.bool,
  onChange: PropTypes.func,
}

export default HHFormDesktopDatePicker
